export default __webpack_public_path__ + "static/media/medium-crumb2.6a6375cc.png";